import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { globalLoader } from "../../actions/commonActions";
import { validEmail } from "../../_shared/commonFunction";
import InputComponent from "../_common/inputComponent";
import { useTranslation } from "react-i18next";

const AddSuperAdminModal = (props) => {
  const { t } = useTranslation();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastNameErr, setLastNameErr] = useState(false);
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  useEffect(() => {
    setPropsToState(); // eslint-disable-next-line
  }, [props?.data]);

  const setPropsToState = () => {
    setFirstName(props?.data?.firstName);
    setLastName(props?.data?.lastName);
    setEmail(props?.data?.email);
  };

  const handleValidation = () => {
    let flag = true;
    if (!firstName) {
      setFirstNameErr(true);
      flag = false;
    }
    if (!lastName) {
      setLastNameErr(true);
      flag = false;
    }

    if (!email) {
      setEmailErr(true);
      flag = false;
    }

    if (invalidEmail) {
      flag = false;
    }
    return flag;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = await handleValidation();
    if (valid) {
      globalLoader(true);
      let obj = {
        firstName: firstName,
        lastName: lastName,
        email: email,
      };
      props.closeModal(obj);
    }
  };
  const validateMail = async (ev) => {
   
    let value = ev;
    let valid = await validEmail(value);
    if (valid) {
      setInvalidEmail(false);
    } else {
      setInvalidEmail(true);
    }
    setEmail(value);
  };

  return (
    <Modal
      open={props.open}
      onClose={() => props.closeModal()}
      center
      classNames={{ modal: "admin-modal" }}
    >
      <div>
        <p className="admin-banner">
          {t(props?.edit ? "superadmin.addSuperAdmin.editTitle" : "superadmin.addSuperAdmin.addTitle")} {props?.role}
        </p>
      </div>
      <form onSubmit={handleSubmit} className="form-own px-3">
        <div className="row">
          <div className="col-6">
            <div className="form-own-group">
              <InputComponent
                placeholder={t("superadmin.addSuperAdmin.firstNamePlaceholder")}
                label={
                  <>
                    {t("superadmin.addSuperAdmin.firstNameLabel")} <span className="color-red">*</span>
                  </>
                }
                type="text"
                name="firstName"
                theme="white"
                value={firstName}
                handleCallback={(val) => {
                  setFirstName(val);
                }}
              />
              <div className="error-text">
                {!firstName && firstNameErr && (
                  <span>{t("superadmin.addSuperAdmin.firstNameRequired")}</span>
                )}
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="form-own-group">
              <InputComponent
                placeholder={t("superadmin.addSuperAdmin.lastNamePlaceholder")}
                label={
                  <>
                    {t("superadmin.addSuperAdmin.lastNameLabel")} <span className="color-red">*</span>
                  </>
                }
                type="text"
                name="lastName"
                theme="white"
                value={lastName}
                handleCallback={(val) => {
                  setLastName(val);
                }}
              />
              <div className="error-text">
                {!lastName && lastNameErr && <span>{t("superadmin.addSuperAdmin.lastNameRequired")}</span>}
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="form-own-group">
              <InputComponent
                placeholder={t("superadmin.addSuperAdmin.emailPlaceholder")}
                label={
                  <>
                    {t("superadmin.addSuperAdmin.emailLabel")} <span className="color-red">*</span>
                  </>
                }
                type="text"
                name="email"
                theme="white"
                value={email}
                handleCallback={(val) => {
                  validateMail(val);
                }}
                maxLength="40"
                disabled={props?.data}
              />
              <div className="error-text">
                {!email && emailErr && <span>{t("superadmin.addSuperAdmin.emailRequired")}</span>}
                {email && invalidEmail && <span>{t("superadmin.addSuperAdmin.emailInvalid")}</span>}
              </div>
            </div>
          </div>
        </div>
        <div className="admin-btn">
          <button
            onClick={() => props.closeModal()}
            className="btn secondary-btn mr-2"
            type="button"
          >
            {t("common.back")}
          </button>
          <button type="submit" className="btn primary-btn ml-2">
            {t("common.submit")}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddSuperAdminModal;
